import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/categories";

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14" aria-label="分类快捷入口">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
        {categoryList.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:border-primary-300 hover:-translate-y-0.5 cursor-pointer"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600 text-2xl transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={cat.icon} aria-hidden="true"></i>
            </span>
            <div className="min-w-0">
              <h3 className="flex items-center gap-1.5 text-base font-semibold text-foreground-950">
                {cat.title}
                <i className="ri-arrow-right-line text-sm text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" aria-hidden="true"></i>
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{cat.subtitle}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}